import getPosition from '../../../Palette/DragDrop/helpers/getPosition';
import isTouchScreenDevice from '../../../Palette/DragDrop/helpers/isTouchScreenDevice';

const clamp = (a, b, x) => {
  return Math.min(Math.max(a, x), b);
};

class Resize {
  constructor(uuid, elem, sizesRef, positionRef, setTimestamp, reOrder) {
    this.uuid = uuid;
    this.elem = elem;
    this.sizesRef = sizesRef;
    this.positionRef = positionRef;
    this.setTimestamp = setTimestamp;
    this.reOrder = reOrder;

    this.addListeners();
  }

  addListeners() {
    this.start = this.start.bind(this);
    this.move = this.move.bind(this);
    this.stop = this.stop.bind(this);

    if (isTouchScreenDevice) {
      this.elem.addEventListener('touchstart', this.start, false);
    } else {
      this.elem.addEventListener('mousedown', this.start, false);
    }
  }

  start(e) {
    e.preventDefault();
    e.stopPropagation();

    this.reOrder(this.uuid);

    this.startPosition = getPosition(e);
    this.oldSizes = [...this.sizesRef.current];

    if (isTouchScreenDevice) {
      window.addEventListener('touchmove', this.move, false);
      window.addEventListener('touchend', this.stop, false);
    } else {
      window.addEventListener('mousemove', this.move, false);
      window.addEventListener('mouseup', this.stop, false);
    }
  }

  move(e) {
    e.preventDefault();
    e.stopPropagation();

    const currentPosition = getPosition(e);

    const delta = [currentPosition[0] - this.startPosition[0], currentPosition[1] - this.startPosition[1]];

    const newSizes = [clamp(500, window.innerWidth - 30, this.oldSizes[0] + delta[0]), clamp(300, window.innerHeight - 30, this.oldSizes[1] - delta[1])];

    this.sizesRef.current = newSizes;
    this.setTimestamp(Date.now());
  }

  stop(e) {
    e.preventDefault();
    e.stopPropagation();

    if (isTouchScreenDevice) {
      window.removeEventListener('touchmove', this.move, false);
      window.removeEventListener('touchend', this.stop, false);
    } else {
      window.removeEventListener('mousemove', this.move, false);
      window.removeEventListener('mouseup', this.stop, false);
    }
  }
}

export default Resize;
